import styled from 'styled-components';

export const Message = styled.h2`{
  font-size: xx-large;
  color: deeppink;
  z-index: 10000000000;
}
`


